<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <mat-icon svgIcon="lock-profile" data-cy="vessel-folder-req-access-requester-modal-icon" />

            <div class="request-title" data-cy="vessel-folder-req-access-requester-modal-header">
                {{ 'request.access.dialog.title' | translate }}
            </div>
            <div class="request-message" data-cy="vessel-folder-req-access-requester-modal-body">
                {{ 'request.access.dialog.message' | translate }}
            </div>
            <div class="buttons-container">
                <div
                    class="cancel button"
                    data-cy="vessel-folder-req-access-requester-modal-cancel-btn"
                    (click)="cancel()">
                    {{ 'request.access.dialog.button.cancel' | translate }}
                </div>
                <div
                    class="request button"
                    data-cy="vessel-folder-req-access-requester-modal-submit-btn"
                    (click)="acceptPublish()">
                    {{ 'request.access.dialog.button.confirm' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
